import { getSpeakerAvatarInfo } from "@/utils/newAvatar";
import Avatar from "@/component/Avatar";
import { ICompanyStaffInfo } from "@/types/share";
import { avatarBgs } from "@/constants/record";
interface StaffItemProps {
  staff: ICompanyStaffInfo;
  index: number
}

const StaffItem = ({ staff, index }: StaffItemProps) => {
  const sharerAvatarInfo = getSpeakerAvatarInfo(staff.avatar);
  return (
    <div className="flex items-center">
      <Avatar
        className="w-8 h-8 text-3 font-600 mr-4"
        userInfo={{
          userId: staff.identityId,
          displayName: staff.realname,
          avatarUrl: sharerAvatarInfo.avatarUrl,
          avatarIndex:
            sharerAvatarInfo.avatarIndex || index % avatarBgs.length,
        }}
      />
      {staff.realname}
    </div>
  );
};

export default StaffItem;
